import { Component } from '@angular/core';
import { ItemsListActionComponent } from '../items-list-action/items-list-action.component';
import { map } from 'rxjs';
import { NtapGlobalConstants, Util } from '@ntap/core';

@Component({
  selector: 'app-verify-agents',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class VerifyAgentsComponent extends ItemsListActionComponent {
  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        const allSelectedForVerification = selectedItems.every((item: any) => {
          const mainType =
            item[NtapGlobalConstants.ATTR_$itemType] ||
            item[NtapGlobalConstants.ATTR_$mainType];
          const statusObradeValue =
            item[Util.getFullAttrName(mainType, 'status_obrade_id')];
          return statusObradeValue === 2;
        });
        return selectedItems.length == 0 || !allSelectedForVerification;
      })
    );
  }
}
